"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            stats: null,
            latestCourse: null,
            latestProgram: null
        };
        GState.bind(this, ['user']);
    },
    onMount: async function () {
        await this.fetchStats();
        this.renderChart();
    },
    fetchStats: async function () {
        try {
            const {error, message, stats} = await Request('/insight/instructor/stats');
            if (error)
                throw new Error(message);
            this.state.stats = stats;
        } catch (error) {
            console.log('Error retreiving instruction stats');
        }
    },
    renderChart: function () {
        const options = {
            chart: {
                height: 100,
                type: 'bar',
                stacked: true,
                toolbar: { show: false }
            },
            grid: {
                show: false,
                padding: {
                    left: 0,
                    right: 0,
                    top: -20,
                    bottom: -15
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '20%',
                    endingShape: 'rounded'
                }
            },
            legend: { show: false },
            dataLabels: { enabled: false },
            colors: [
                '#5A8DEE',
                '#828D99'
            ],
            series: [
                {
                    name: '2024',
                    data: [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ]
                },
                {
                    name: '2023',
                    data: [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ]
                }
            ],
            xaxis: {
                categories: [
                    '0',
                    '',
                    '',
                    '',
                    '',
                    '10',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '15',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '20'
                ],
                axisBorder: { show: false },
                axisTicks: { show: false },
                labels: {
                    style: { colors: '#828D99' },
                    offsetY: -5
                }
            },
            yaxis: {
                show: false,
                floating: true
            },
            tooltip: { x: { show: false } }
        };
        new ApexCharts($('#performance-chart')[0], options).render();
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Dashboard/Instructor/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_ApexCharts = require("./apexcharts"),
    ApexCharts = module_ApexCharts.default || module_ApexCharts,
    Locale_template = require("../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    Card_CourseInsight_template = require("../../../components/Card-CourseInsight.marko"),
    Card_CourseInsight_tag = marko_loadTag(Card_CourseInsight_template),
    Image_template = require("../../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    WSAdapt_template = require("../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Wrapper_Admin_template = require("../../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "px-2"
      },
    marko_attrs1 = {
        "class": "text-muted font-medium-2"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("1bc913"),
    marko_node0 = marko_createElement("br", null, "8", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "row px-2"
      },
    marko_attrs3 = {
        "class": "font-medium-1 text-muted mb-5"
      },
    marko_attrs4 = {
        "class": "font-medium-1 text-muted mb-5"
      },
    marko_attrs5 = {
        "class": "font-medium-1 text-muted mb-5"
      },
    marko_attrs6 = {
        "class": "btn btn-primary mr-3 my-25"
      },
    marko_attrs7 = {
        "class": "font-medium-1 text-muted mb-5"
      },
    marko_attrs8 = {
        "class": "btn btn-primary mr-3 my-25"
      },
    marko_attrs9 = {
        "class": "col-6 p-1"
      },
    marko_attrs10 = {
        "class": "px-2 py-1 border border-2 round"
      },
    marko_attrs11 = {
        "class": "text-muted"
      },
    marko_attrs12 = {
        "class": "font-large-4"
      },
    marko_attrs13 = {
        "class": "col-6 p-1"
      },
    marko_attrs14 = {
        "class": "px-2 py-1 border border-2 round"
      },
    marko_attrs15 = {
        "class": "text-muted"
      },
    marko_attrs16 = {
        "class": "font-large-4"
      },
    marko_attrs17 = {
        "class": "col-6 p-1"
      },
    marko_attrs18 = {
        "class": "px-2 py-1 border border-2 round"
      },
    marko_attrs19 = {
        "class": "text-muted"
      },
    marko_attrs20 = {
        "class": "font-large-4"
      },
    marko_attrs21 = {
        "class": "col-6 p-1"
      },
    marko_attrs22 = {
        "class": "px-2 py-1 border border-2 round"
      },
    marko_attrs23 = {
        "class": "text-muted"
      },
    marko_attrs24 = {
        "class": "font-large-4"
      },
    marko_attrs25 = {
        "class": "col-6 p-1"
      },
    marko_attrs26 = {
        "class": "px-2 py-1 border border-2 round"
      },
    marko_attrs27 = {
        "class": "text-muted"
      },
    marko_attrs28 = {
        "class": "font-large-4"
      },
    marko_attrs29 = {
        "class": "col-12 p-1"
      },
    marko_attrs30 = {
        "class": "px-2 py-1 border border-2 round"
      },
    marko_attrs31 = {
        "class": "text-muted"
      },
    marko_node1 = marko_createElement("div", {
        id: "performance-chart"
      }, "89", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      nobreadcrump: true,
      renderBody: function(out, { page }) {
        Row_tag({
            renderBody: function(out) {
              WSAdapt_tag({
                  class: "col",
                  renderBody: function(out) {
                    out.be("section", marko_attrs0, "3", component);

                    out.be("h5", null, "4", component);

                    Locale_tag({
                        text: ("Good day, " + state.user.first_name) + "!"
                      }, out, __component, "5");

                    out.ee();

                    out.be("p", marko_attrs1, "6", component);

                    Locale_tag({
                        renderBody: function(out) {
                          out.t("Below are your pending activities");
                        }
                      }, out, __component, "7");

                    out.ee();

                    out.ee();

                    out.n(marko_node0, component);

                    out.be("section", marko_attrs2, "9", component);

                    WSAdapt_tag({
                        ns: "col-6",
                        qs: "col-10",
                        hs: "col-10",
                        class: "my-1",
                        renderBody: function(out) {
                          if (state.latestCourse) {
                            Card_CourseInsight_tag(latestCourse, out, __component, "11");
                          } else {
                            Row_tag({
                                style: "height:18rem",
                                class: "m-0 d-flex align-items-center border round px-2 py-2",
                                col: [
                                    {
                                        class: "col-5",
                                        renderBody: function(out) {
                                          Image_tag({
                                              alt: "Image",
                                              src: "/images/illustration/create-course.png",
                                              class: "img-fluid"
                                            }, out, __component, "14");
                                        }
                                      },
                                    {
                                        renderBody: function(out) {
                                          out.be("h5", null, "16", component);

                                          Locale_tag({
                                              renderBody: function(out) {
                                                out.t("No active course or program");
                                              }
                                            }, out, __component, "17");

                                          out.ee();

                                          out.be("p", marko_attrs3, "18", component);

                                          Locale_tag({
                                              renderBody: function(out) {
                                                out.t("Create a new course or program and track its performances right here.");
                                              }
                                            }, out, __component, "19");

                                          out.ee();

                                          route_link_tag({
                                              type: "button",
                                              href: "/create-course",
                                              class: "btn btn-primary mr-3 my-25",
                                              renderBody: function(out) {
                                                Locale_tag({
                                                    renderBody: function(out) {
                                                      out.t("Add course");
                                                    }
                                                  }, out, __component, "21");
                                              }
                                            }, out, __component, "20");

                                          route_link_tag({
                                              type: "button",
                                              href: "/create-program",
                                              class: "btn btn-outline-primary mr-3 my-25",
                                              renderBody: function(out) {
                                                Locale_tag({
                                                    renderBody: function(out) {
                                                      out.t("Add program");
                                                    }
                                                  }, out, __component, "23");
                                              }
                                            }, out, __component, "22");
                                        }
                                      }
                                  ]
                              }, out, __component, "12");
                          }
                        }
                      }, out, __component, "10");

                    WSAdapt_tag({
                        ns: "col-6",
                        qs: "col-10",
                        hs: "col-10",
                        class: "my-1",
                        renderBody: function(out) {
                          if (state.latestCourse) {} else {
                            Row_tag({
                                style: "height:18rem",
                                class: "m-0 d-flex align-items-center border round px-2 py-2",
                                col: [
                                    {
                                        class: "col-5",
                                        renderBody: function(out) {
                                          Image_tag({
                                              alt: "Image",
                                              src: "/images/illustration/live-session.png",
                                              class: "img-fluid"
                                            }, out, __component, "27");
                                        }
                                      },
                                    {
                                        renderBody: function(out) {
                                          out.be("h5", null, "29", component);

                                          Locale_tag({
                                              renderBody: function(out) {
                                                out.t("No live session");
                                              }
                                            }, out, __component, "30");

                                          out.ee();

                                          out.be("p", marko_attrs4, "31", component);

                                          Locale_tag({
                                              renderBody: function(out) {
                                                out.t("You have no pending live session on the schedule.");
                                              }
                                            }, out, __component, "32");

                                          out.ee();

                                          route_link_tag({
                                              type: "button",
                                              href: "/live-sessions",
                                              class: "btn btn-primary mr-3 my-25",
                                              renderBody: function(out) {
                                                Locale_tag({
                                                    renderBody: function(out) {
                                                      out.t("Create new session");
                                                    }
                                                  }, out, __component, "34");
                                              }
                                            }, out, __component, "33");
                                        }
                                      }
                                  ]
                              }, out, __component, "25");
                          }
                        }
                      }, out, __component, "24");

                    WSAdapt_tag({
                        ns: "col-6",
                        qs: "col-10",
                        hs: "col-10",
                        class: "my-1",
                        renderBody: function(out) {
                          if (state.latestCourse) {} else {
                            Row_tag({
                                style: "height:18rem",
                                class: "m-0 d-flex align-items-center border round px-2 py-2",
                                col: [
                                    {
                                        class: "col-5",
                                        renderBody: function(out) {
                                          Image_tag({
                                              alt: "Image",
                                              src: "/images/illustration/assigmnent.png",
                                              class: "img-fluid"
                                            }, out, __component, "38");
                                        }
                                      },
                                    {
                                        renderBody: function(out) {
                                          out.be("h5", null, "40", component);

                                          Locale_tag({
                                              renderBody: function(out) {
                                                out.t("No assignment");
                                              }
                                            }, out, __component, "41");

                                          out.ee();

                                          out.be("p", marko_attrs5, "42", component);

                                          Locale_tag({
                                              renderBody: function(out) {
                                                out.t("Track all active assignments and students submissions here.");
                                              }
                                            }, out, __component, "43");

                                          out.ee();

                                          out.be("button", marko_attrs6, "44", component, null, 0, {
                                              onclick: __component.d("click", () => window.Extensions.run('EvaluationPro', { type: 'ASSG' }), false)
                                            });

                                          Locale_tag({
                                              renderBody: function(out) {
                                                out.t("Create assignment");
                                              }
                                            }, out, __component, "45");

                                          out.ee();
                                        }
                                      }
                                  ]
                              }, out, __component, "36");
                          }
                        }
                      }, out, __component, "35");

                    WSAdapt_tag({
                        ns: "col-6",
                        qs: "col-10",
                        hs: "col-10",
                        class: "my-1",
                        renderBody: function(out) {
                          if (state.latestCourse) {} else {
                            Row_tag({
                                style: "height:18rem",
                                class: "m-0 d-flex align-items-center border round px-2 py-2",
                                col: [
                                    {
                                        class: "col-5",
                                        renderBody: function(out) {
                                          Image_tag({
                                              alt: "Image",
                                              src: "/images/illustration/link-accounts.png",
                                              class: "img-fluid"
                                            }, out, __component, "49");
                                        }
                                      },
                                    {
                                        renderBody: function(out) {
                                          out.be("h5", null, "51", component);

                                          Locale_tag({
                                              renderBody: function(out) {
                                                out.t("No activity");
                                              }
                                            }, out, __component, "52");

                                          out.ee();

                                          out.be("p", marko_attrs7, "53", component);

                                          Locale_tag({
                                              renderBody: function(out) {
                                                out.t("Be aware of your students activities & feedback");
                                              }
                                            }, out, __component, "54");

                                          out.ee();

                                          out.be("button", marko_attrs8, "55", component, null, 0, {
                                              onclick: __component.d("click", () => window.Extensions.run('Bloum', {}), false)
                                            });

                                          Locale_tag({
                                              renderBody: function(out) {
                                                out.t("Engage");
                                              }
                                            }, out, __component, "56");

                                          out.ee();

                                          route_link_tag({
                                              type: "button",
                                              href: "/students",
                                              class: "btn btn-outline-primary mr-3 my-25",
                                              renderBody: function(out) {
                                                Locale_tag({
                                                    renderBody: function(out) {
                                                      out.t("View Students");
                                                    }
                                                  }, out, __component, "58");
                                              }
                                            }, out, __component, "57");
                                        }
                                      }
                                  ]
                              }, out, __component, "47");
                          }
                        }
                      }, out, __component, "46");

                    out.ee();
                  }
                }, out, __component, "2");

              WSAdapt_tag({
                  ns: "col-md-3 col-4",
                  qs: "col-md-4 col-5",
                  hs: "d-none",
                  style: "top:12vh",
                  class: "position-sticky h-100 row",
                  renderBody: function(out) {
                    const stats = state.stats || {}

                    out.be("section", marko_attrs9, "60", component);

                    out.be("div", marko_attrs10, "61", component);

                    out.be("h6", marko_attrs11, "62", component);

                    Locale_tag({
                        renderBody: function(out) {
                          out.t("No. of Students");
                        }
                      }, out, __component, "63");

                    out.ee();

                    out.e("div", marko_attrs12, "64", component, 1)
                      .t(stats.students || 0, component);

                    out.ee();

                    out.ee();

                    out.be("section", marko_attrs13, "65", component);

                    out.be("div", marko_attrs14, "66", component);

                    out.be("h6", marko_attrs15, "67", component);

                    Locale_tag({
                        renderBody: function(out) {
                          out.t("No. of Courses");
                        }
                      }, out, __component, "68");

                    out.ee();

                    out.e("div", marko_attrs16, "69", component, 1)
                      .t(stats.courses || 0, component);

                    out.ee();

                    out.ee();

                    out.be("section", marko_attrs17, "70", component);

                    out.be("div", marko_attrs18, "71", component);

                    out.be("h6", marko_attrs19, "72", component);

                    Locale_tag({
                        renderBody: function(out) {
                          out.t("No. of Programs");
                        }
                      }, out, __component, "73");

                    out.ee();

                    out.e("div", marko_attrs20, "74", component, 1)
                      .t(stats.programs || 0, component);

                    out.ee();

                    out.ee();

                    out.be("section", marko_attrs21, "75", component);

                    out.be("div", marko_attrs22, "76", component);

                    out.be("h6", marko_attrs23, "77", component);

                    Locale_tag({
                        renderBody: function(out) {
                          out.t("No. of Sessions");
                        }
                      }, out, __component, "78");

                    out.ee();

                    out.e("div", marko_attrs24, "79", component, 1)
                      .t(stats.sessions || 0, component);

                    out.ee();

                    out.ee();

                    out.be("section", marko_attrs25, "80", component);

                    out.be("div", marko_attrs26, "81", component);

                    out.be("h6", marko_attrs27, "82", component);

                    Locale_tag({
                        renderBody: function(out) {
                          out.t("No. of Enrollments");
                        }
                      }, out, __component, "83");

                    out.ee();

                    out.e("div", marko_attrs28, "84", component, 1)
                      .t(stats.enrollments || 0, component);

                    out.ee();

                    out.ee();

                    out.be("section", marko_attrs29, "85", component);

                    out.be("div", marko_attrs30, "86", component);

                    out.be("h6", marko_attrs31, "87", component);

                    Locale_tag({
                        renderBody: function(out) {
                          out.t("Weekly Performances");
                        }
                      }, out, __component, "88");

                    out.ee();

                    out.n(marko_node1, component);

                    out.ee();

                    out.ee();
                  }
                }, out, __component, "59");
            }
          }, out, __component, "1");
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
